module.exports = __webpack_public_path__ + "img/27.5.COD.15691edd.png";